import { useQuery } from '@apollo/client';
import { PeopleOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';
import { AuditLogList } from '~/components/AuditLogs';
import { RouterBreadcrumbs } from '~/components/RouterBreadcrumbs';
import { ScrollableRouterTabs } from '~/components/RouterTabs';
import { PageContainer } from '~/components/page-layout';
import { Toolbar } from '~/components/toolbar';
import { useLink } from '~/hooks/link';
import { NetworkUserAuditLogsDocument } from '../queries/AuditLogs.generated';
import { tabs } from './lib/tabs';

export const UserAuditLogs = () => {
  const { t } = useTranslation();
  const params = useParams<{ userId: string }>();
  const userId = parseInt(params.userId ?? '');

  const link = useLink();

  const { data, loading } = useQuery(NetworkUserAuditLogsDocument, {
    variables: { userId },
  });

  const user = data?.user;

  if (loading || !user) return !loading ? <Navigate to={link('/not-found')} replace /> : null;

  return (
    <>
      <Toolbar
        breadcrumbsLabel={<RouterBreadcrumbs />}
        titleIcon={<PeopleOutlined />}
        titleText={user.name}
      />

      <ScrollableRouterTabs current={t('common.tabs.audit_logs')} tabs={tabs(t)} />

      <PageContainer>
        <AuditLogList recordTypes={['User']} userId={userId} />
      </PageContainer>
    </>
  );
};
